import fetch from "auth/FetchInterceptor";

const MarketingService = {};

// --- Campaigns ---
MarketingService.getCampaigns = function (filters = {}) {
  const params = new URLSearchParams();
  if (filters.status) params.append("status", filters.status);
  if (filters.channel) params.append("channel", filters.channel);
  const qs = params.toString();
  return fetch({
    url: `/marketing/campaigns/${qs ? `?${qs}` : ""}`,
    method: "get",
  });
};

MarketingService.getCampaign = function (campaignId) {
  return fetch({
    url: `/marketing/campaigns/${campaignId}/`,
    method: "get",
  });
};

MarketingService.createCampaign = function (data) {
  return fetch({
    url: `/marketing/campaigns/`,
    method: "post",
    data,
  });
};

MarketingService.updateCampaign = function (campaignId, data) {
  return fetch({
    url: `/marketing/campaigns/${campaignId}/`,
    method: "put",
    data,
  });
};

MarketingService.deleteCampaign = function (campaignId) {
  return fetch({
    url: `/marketing/campaigns/${campaignId}/`,
    method: "delete",
  });
};

MarketingService.sendCampaign = function (campaignId, scheduledAt = null) {
  return fetch({
    url: `/marketing/campaigns/${campaignId}/send/`,
    method: "post",
    data: { scheduled_at: scheduledAt },
  });
};

MarketingService.getRecipients = function (campaignId, statusFilter = null) {
  const params = new URLSearchParams();
  if (statusFilter) params.append("status", statusFilter);
  const qs = params.toString();
  return fetch({
    url: `/marketing/campaigns/${campaignId}/recipients/${qs ? `?${qs}` : ""}`,
    method: "get",
  });
};

MarketingService.previewAudience = function (data) {
  return fetch({
    url: `/marketing/audience-preview/`,
    method: "post",
    data,
  });
};

// --- Templates ---
MarketingService.getTemplates = function (channel = null) {
  const params = new URLSearchParams();
  if (channel) params.append("channel", channel);
  const qs = params.toString();
  return fetch({
    url: `/marketing/templates/${qs ? `?${qs}` : ""}`,
    method: "get",
  });
};

MarketingService.createTemplate = function (data) {
  return fetch({
    url: `/marketing/templates/`,
    method: "post",
    data,
  });
};

MarketingService.updateTemplate = function (templateId, data) {
  return fetch({
    url: `/marketing/templates/${templateId}/`,
    method: "put",
    data,
  });
};

MarketingService.deleteTemplate = function (templateId) {
  return fetch({
    url: `/marketing/templates/${templateId}/`,
    method: "delete",
  });
};

// --- AI (Claude) ---
MarketingService.getAiSettings = function () {
  return fetch({
    url: `/marketing/ai-settings/`,
    method: "get",
  });
};

MarketingService.updateAiSettings = function (apiKey) {
  return fetch({
    url: `/marketing/ai-settings/`,
    method: "put",
    data: { api_key: apiKey },
  });
};

MarketingService.aiRecommend = function (data) {
  return fetch({
    url: `/marketing/ai-recommend/`,
    method: "post",
    data,
  });
};

// Hamilton AI: category-based campaign strategy recommendation.
MarketingService.aiStrategy = function (data) {
  return fetch({
    url: `/marketing/ai-strategy/`,
    method: "post",
    data,
  });
};

// Upload an Excel/CSV file and get contacts split into emails + phones.
MarketingService.importRecipients = function (file) {
  const formData = new FormData();
  formData.append("file", file);
  return fetch({
    url: `/marketing/import-recipients/`,
    method: "post",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
};

// Newsletter subscribers list (storefront + popup sign-ups)
MarketingService.getNewsletterSubscribers = function (filters = {}) {
  const params = new URLSearchParams();
  if (filters.q) params.append("q", filters.q);
  if (filters.page) params.append("page", filters.page);
  if (filters.page_size) params.append("page_size", filters.page_size);
  const qs = params.toString();
  return fetch({
    url: `/newsletter-subscribers/${qs ? `?${qs}` : ""}`,
    method: "get",
  });
};

export default MarketingService;
